<template>
    <tr v-if="staff">
        <td> {{ staff.username }}</td>
        <td> {{ staff.name }}</td>
        <td> {{ staff.phone }}</td>
        <td>
            <router-link
                v-if="$store.state.provider.current_staff.theme_name == 'manager'"
                :data-tooltip="$t('ui.general.edit') +' '+ $t('models.roles')"
                :to="{name: 'edit_role', params: {identity: staff.role_identity}}"
            >
                {{ $parent.role_name(staff) }}
            </router-link>
            <span v-else>
                {{ $parent.role_name(staff) }}
            </span>
        </td>
        <td>
            {{ $t('ui.theme_names.' + staff.theme_name) }}
        </td>
        <td>
            {{ $parent.station_name(staff) }}
        </td>
        <td>
            <span v-if="!staff.is_banned">
                <!-- 正常 -->
                <i class="check icon"></i> {{ $t('ui.pages.staffs.normal') }}
            </span>
            <span v-if="staff.is_banned">
                <!-- 停權 -->
                <i class="remove icon"></i> {{ $t('ui.pages.staffs.banned') }}
            </span>
        </td>
        <td>
            <router-link :to="{name: 'appraisals', params: { staff_identity: staff.identity }}" class="ui basic blue button">
                {{ $t('ui.pages.staffs.appraisals') }}
            </router-link>
            <router-link :to="{name: 'edit_staff', params: {identity: staff.identity}}" class="ui basic green button">
                {{ $t('ui.general.edit') }}
            </router-link>
            <button class="ui basic button" @click="$parent.toggle_is_banned(staff)" :class="{ positive: staff.is_banned, negative: !staff.is_banned }">
                <span v-if="staff.is_banned">
                    <!-- 復權 -->
                    {{ $t('ui.pages.staffs.unbanned') }}
                </span>
                <span v-else>
                    <!-- 停權 -->
                    {{ $t('ui.pages.staffs.banned') }}
                </span>
            </button>
            <a @click.prevent="$parent.delete_staff(staff)" class="ui basic red button">
                {{ $t('ui.general.delete') }}
            </a>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderStaffsIndexItem",
    props: {
        staff: Object
    },
    data() {
        return {
            is_loading: false,
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    },

}
</script>

<style scoped lang="scss">
    .tooltip.help {
        position: absolute;
        cursor: pointer;
        top: -6px;
        right: -16px
    }
</style>
